import { render } from "./Transactions.vue?vue&type=template&id=885dfb44&scoped=true"
import script from "./Transactions.vue?vue&type=script&lang=js"
export * from "./Transactions.vue?vue&type=script&lang=js"

import "./Transactions.vue?vue&type=style&index=0&id=885dfb44&scoped=true&lang=css"
import "./Transactions.vue?vue&type=style&index=1&id=885dfb44&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-885dfb44"]])

export default __exports__